import { useCallback, useEffect, useRef, useState } from 'react';
// TODO(Jenky): to discuss
var INPUT_DEBOUNCE_TIMEOUT = 200;
export default function useInputDebounce(props) {
    var _a, _b;
    var controlled = props.controlled, initialValue = props.initialValue, onChange = props.onChange, format = props.format;
    var formattedInitialValue = (_b = (_a = format === null || format === void 0 ? void 0 : format(initialValue)) !== null && _a !== void 0 ? _a : initialValue) !== null && _b !== void 0 ? _b : '';
    var _c = useState(formattedInitialValue), inputValue = _c[0], setInputValue = _c[1];
    var timeoutRef = useRef(0);
    var didMountRef = useRef(false);
    var onInputChange = useCallback(function (e) {
        var _a;
        var formattedValue = (_a = format === null || format === void 0 ? void 0 : format(e.currentTarget.value)) !== null && _a !== void 0 ? _a : e.currentTarget.value;
        setInputValue(formattedValue);
    }, [initialValue]);
    var controlledOnInputChange = function (e) {
        var _a;
        var formattedValue = (_a = format === null || format === void 0 ? void 0 : format(e.currentTarget.value)) !== null && _a !== void 0 ? _a : e.currentTarget.value;
        onChange === null || onChange === void 0 ? void 0 : onChange(formattedValue, e);
    };
    useEffect(function () {
        if (controlled)
            return function () { };
        clearTimeout(timeoutRef.current);
        if (didMountRef.current) {
            // https://stackoverflow.com/questions/55550096/ts2322-type-timeout-is-not-assignable-to-type-number-when-running-unit-te
            timeoutRef.current = window.setTimeout(function () {
                if (onChange)
                    onChange(inputValue);
            }, INPUT_DEBOUNCE_TIMEOUT);
        }
        didMountRef.current = true;
        return function () { return clearTimeout(timeoutRef.current); };
    }, [inputValue]);
    if (controlled) {
        return {
            onInputChange: controlledOnInputChange,
            inputValue: formattedInitialValue
        };
    }
    return {
        onInputChange: onInputChange,
        inputValue: inputValue
    };
}
